import { render, staticRenderFns } from "./CustomerReviewContentCell.vue?vue&type=template&id=1905df91&"
import script from "./CustomerReviewContentCell.vue?vue&type=script&lang=js&"
export * from "./CustomerReviewContentCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports